import React from "react";
// import RouterErrorPage from "../../Layouts/Router/RouterErrorPage";
import Protected from "./Protected";
import Login from "../../pages/Login";
import ForgotPassword from "../../pages/ForgotPassword";
import ResetPassword from "../../pages/ResetPassword";
import LoginAsSuperAdmin from "../../components/LoginAsSuperAdmin";

export const Auth = {
  element: (
    <LoginAsSuperAdmin>
      <Protected />
    </LoginAsSuperAdmin>
  ),
  //   errorElement: <RouterErrorPage />,
  children: [
    {
      element: <Login />,
      path: "/",
    },
    {
      element: <ForgotPassword />,
      path: "/forgotpassword",
    },
    {
      element: <ResetPassword />,
      path: "/resetpassword",
    },
  ],
};
